import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
const bioMatrixScanVuex = createNamespacedHelpers("bioMatrixScan");
//import {v5 as uuidv5} from 'uuid';
export default {
  name: "bioMatrixScan",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    ...userVuex.mapState(["userData"]),
    ...bioMatrixScanVuex.mapState(['showPop', 'taskInfo', 'faceUidCountdown'])
  },
  data() {
    return {
      popBioMatrixScanShow: false,
      popBioMatrixScanCheckShow: false,
      popFaceScanShow: false,
      popBioMatrixScanNextShow: false,
      popBioMatrixScanRewardShow: false,
      faceTimer: null,
      popFaceScanLogShow: false
    };
  },
  beforeRouteLeave(to, from, next) {
    this.setShowPop(this.popBioMatrixScanShow);
    this.popBioMatrixScanShow = false;
    this.popBioMatrixScanCheckShow = false;
    this.popFaceScanShow = false;
    this.popBioMatrixScanNextShow = false;
    this.popBioMatrixScanRewardShow = false;
    this.popFaceScanLogShow = false;
    clearInterval(this.faceTimer);
    this.$nextTick(() => {
      next();
    });
  },
  watch: {},
  async mounted() {
    // if(this.$route.query.hidden == 1 || this.showPop){
    //   this.popFaceScanShow = false
    // }
    // else if(this.faceUidCountdown != -1){
    //   this.popFaceScanShow = true
    // }
    // if (this.showPop) {
    //   this.popBioMatrixScanShow = this.showPop; // 恢复弹窗状态
    //   this.setShowPop(false)
    // }
    // else{
    //   this.setStartTime(0)
    // }
    // if(!this.taskInfo)
    // {
    //   await this.getTaskInfo()
    // }
    // await this.faceCountdown();
    // this.popFaceScanShow = true
  },
  methods: {
    ...userVuex.mapMutations(['setUserData']),
    ...bioMatrixScanVuex.mapMutations(['setShowPop', 'setStartTime', 'setFaceUidCountdown']),
    ...bioMatrixScanVuex.mapActions(['getTaskInfo', 'getFaceUidCountdown']),
    doChecked(url) {
      if (!this.taskInfo) {
        return;
      }
      if (this.faceUidCountdown == -1 && this.taskInfo.completed_count >= 1) {
        this.$router.push(url);
      } else {
        if (this.faceUidCountdown == 0) {
          this.popBioMatrixScanRewardShow = true;
        } else if (this.faceUidCountdown > 0) {
          this.popBioMatrixScanNextShow = true;
        } else {
          this.popBioMatrixScanCheckShow = true;
        }
      }
    },
    jumpTo(url, show) {
      this.popBioMatrixScanCheckShow = false;
      if (show && (this.taskInfo.completed_count == 0 || this.faceUidCountdown != -1)) {
        // if(this.taskInfo.completed_count >= 1){
        //   return
        // }
        // if(this.taskInfo.completed_count >= 100){
        //   return
        // }
        this.setStartTime(Date.now());
        this.popBioMatrixScanShow = true;
      }
      this.$router.push(url);
    },
    // backTaskList(){
    //   this.$router.push('/earn');
    // }
    async faceCountdown() {
      await this.getFaceUidCountdown();
      if (this.faceUidCountdown != -1) {
        if (this.faceUidCountdown > 0) {
          this.faceTimer = setInterval(() => {
            if (this.faceUidCountdown > 0) {
              let faceCD = this.faceUidCountdown - 1;
              this.setFaceUidCountdown(faceCD);
            } else {
              clearInterval(this.faceTimer);
              //this.setFaceUidCountdown(0)
            }
          }, 1000);
        }
      }
    },
    showLog() {
      this.popFaceScanLogShow = true;
    }
  }
};